module.exports = __webpack_public_path__ + "img/resLevelBarMarker.d9abf4b5.svg";